"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconCar = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M13.2727 4.5 5.0909 4.5 1 9.4091 1 11.8636 2.6364 11.8636C2.6364 13.2192 3.7353 14.3182 5.0909 14.3182C6.4465 14.3182 7.5455 13.2192 7.5455 11.8636L12.4545 11.8636C12.4545 13.2192 13.5535 14.3182 14.9091 14.3182C16.2647 14.3182 17.3636 13.2192 17.3636 11.8636L19 11.8636 19 9.4091C19 8.5009 18.2718 7.7727 17.3636 7.7727L15.7273 7.7727 13.2727 4.5M5.5 5.7273 8.7727 5.7273 8.7727 7.7727 3.8636 7.7727 5.5 5.7273M10 5.7273 12.8636 5.7273 14.4673 7.7727 10 7.7727 10 5.7273M5.0909 10.6364C5.7687 10.6364 6.3182 11.1858 6.3182 11.8636C6.3182 12.5414 5.7687 13.0909 5.0909 13.0909C4.4131 13.0909 3.8636 12.5414 3.8636 11.8636C3.8636 11.1858 4.4131 10.6364 5.0909 10.6364M14.9091 10.6364C15.5869 10.6364 16.1364 11.1858 16.1364 11.8636C16.1364 12.5414 15.5869 13.0909 14.9091 13.0909C14.2313 13.0909 13.6818 12.5414 13.6818 11.8636C13.6818 11.1858 14.2313 10.6364 14.9091 10.6364Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconCar')(IconCar);